// Keep document payloads and bearer URLs out of HTTP diagnostics.
export function documentHttpContext(value) {
  const config = value && (value.config || (value.response && value.response.config));
  const url = (config && config.url) || '';
  if (!/\/(documents|kyc)\/|\/(account|withdraw)\/bank\/|\/account\/realname\/|\/user\/(idcard|gender-verification)\/|\/account\/withdraw\/apply/.test(url)) return value;
  return { status: value.status || (value.response && value.response.status),
    code: value.data && value.data.code,
    config: { url: url.split('?')[0], method: config.method }, sensitivePayloadRedacted: true };
}
